import * as React from "react"

import { cn } from "@/lib/utils"

const isNonNegativeNumberInput = (type, min, allowNegative) => {
  if (allowNegative) return false
  if (type !== "number") return false
  if (min === undefined || min === null || min === "") return true
  const numericMin = Number(min)
  return Number.isFinite(numericMin) && numericMin >= 0
}

const Input = React.forwardRef(
  (
    {
      className,
      type,
      min,
      allowNegative,
      onKeyDown,
      onPaste,
      onChange,
      ...props
    },
    ref,
  ) => {
    const preventNegative = isNonNegativeNumberInput(type, min, allowNegative)

    const handleKeyDown = (event) => {
      if (preventNegative && ["-", "+", "e", "E"].includes(event.key)) {
        event.preventDefault()
        return
      }
      onKeyDown?.(event)
    }

    const handlePaste = (event) => {
      if (preventNegative) {
        const pastedValue = event.clipboardData.getData("text")
        if (String(pastedValue).trim().startsWith("-")) {
          event.preventDefault()
          return
        }
      }
      onPaste?.(event)
    }

    const handleChange = (event) => {
      if (preventNegative && Number(event.target.value) < 0) {
        event.target.value = ""
      }
      onChange?.(event)
    }

    return (
      <input
        type={type}
        min={min}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        onChange={handleChange}
        {...props}
      />
    )
  },
)
Input.displayName = "Input"

export { Input }
